export const DATE_TIME_FORMAT = 'dd-MM-yyyy HH:mm'
export const DATE_TIME_AGENDA_FORMAT = "dd 'de' LLL. 'de' yyyy',' HH:mm"
export const DATE_TIME_SECONDS_FORMAT = 'dd-MM-yyyy HH:mm:ss'
export const DATE_FORMAT = 'dd-MM-yyyy'
export const DATE_TIME_FULL_HUMAN = 'dd-MM-yyyy HH:mm:ss'
export const DATE_FORMAT_HUMAN = 'dd-MM-yyyy'
export const TIME_FORMAT = 'HH:mm:ss'
export const DATE_MONTH_FORMAT = 'LLLL, yyyy'
